import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/home/runner/work/fc-datastore/fc-datastore/client-v3/src/layouts/default.vue").then(m => m.default || m)),
  empty: defineAsyncComponent(() => import("/home/runner/work/fc-datastore/fc-datastore/client-v3/src/layouts/empty.vue").then(m => m.default || m)),
  error: defineAsyncComponent(() => import("/home/runner/work/fc-datastore/fc-datastore/client-v3/src/layouts/error.vue").then(m => m.default || m))
}